<template lang="pug">
  v-bottom-sheet(
    v-model="model"
    v-glass=".9"
    eager)
    v-card(
      ref="card"
      v-glass="{ alphaValue: .8, root: true }"
      :height="draggable.height")
      v-toolbar.no-radius(
        data-glass
        flat)
        slot(name="title")
        v-spacer
        v-scale-transition(
          mode="out-in")
          v-btn(
            :key="`closeButtonOnBlockingMenu`"
            @click="onClose"
            icon)
            v-icon {{ mdiClose }}
      v-card-text.pb-0(
        ref="content"
        data-glass
        :style="style")
        slot(name="items")
</template>

<script>
import { ref, computed, onMounted, reactive, toRefs, watch, onBeforeUnmount, onUnmounted } from '@vue/composition-api'
import setDraggable from './set-draggable/'
import { mdiClose } from '@mdi/js'
import { page, vuetify } from '@iez/core'
import { debounce } from 'lodash'

export default {
  props: {
    value: Boolean,
    items: Array
  },

  setup (props, { emit }) {
    const content = ref(null)
    const card = ref(null)

    const onClose = () => {
      state.model = false
      emit(`scroll-top`, { scrollTop: null })
    }

    const debouncedHandler = debounce(
      ({ target: { scrollTop }}) => {
        emit(`scroll-top`, { scrollTop })
      },
      20
    )
    onMounted(() => {
      content.value.addEventListener(`scroll`, debouncedHandler)
    })
    onBeforeUnmount(() => {
      content.value.removeEventListener(`scroll`, debouncedHandler)
    })

    watch(
      () => [props.value, props.items?.length],
      ([value]) => {
        if (value && state.draggable?.reset) {
          emit(`scroll-top`, { scrollTop: 0 })
          state.draggable.reset()
        }
      }
    )

    const state = reactive({
      draggable: setDraggable({ card, content, onClose }),
      model: computed({
        get: () => props.value,
        set: value => {
          emit(`input`, value)
        }
      }),
      style: computed(
        () => ({
          ...state.draggable.isClippedTop
            ? {
              overflowY: `scroll`,
              height: `${state.draggable.maxContentHeight}px`
            } : null
        })
      )
    })

    return {
      card,
      content,
      ...toRefs(state),
      onClose,
      mdiClose
    }
  }
}
</script>

<style scoped>
>>> .v-sheet {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
</style>
